export enum ProgressBarStatus {
  COMPLETED = 'COMPLETED',
  INCOMPLETE = 'INCOMPLETE',
  ACTIVE = 'ACTIVE',
}

export interface ProgressItem {
  label: string;
  status: ProgressBarStatus;
}
